<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='icon'
      :titleIconColor='iconColor'
    >
    <!-- :showEdit='!estimate.is_sold'
      @edit='openEdit' -->
      <v-card-text>
        <!-- Invoicing notes removed - 2021-05-25 -->
        <!-- <span v-if='!estimate.invoicing_notes'>No invoicing notes...</span>
        <span v-html='estimate.invoicing_notes'></span> -->
        <v-row>
          <v-col cols='12' md='4'>
            <v-tooltip top>
              <template v-slot:activator='{ on }'>
                <v-btn
                  small
                  block
                  :disabled='estimate.is_sold'
                  @click='openEditHold'
                  v-on='on'
                  :outlined='estimate.hold_invoices ? false : true'
                  :depressed='estimate.hold_invoices ? true : false'
                  :color="estimate.hold_invoices ? 'error' : 'grey'"
                >
                  <v-icon small left>{{$icons.hold.icon}}</v-icon>
                  Hold
                </v-btn>
              </template>
              <span v-if='estimate.hold_invoices'>
                Click to remove hold & edit reason
              </span>
              <span v-else>
                Click to hold invoices
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols='12' md='8'>
            <p v-if='estimate.hold_invoices'>
              <strong>Hold Reason:</strong>
              {{ estimate.hold_invoices_reason }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </wc-data-box>

    <!-- <wc-dialog
      :title='title'
      :icon='icon'
      :iconColor='iconColor'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-text-field
        label='Notes'
        v-model='estimateCopy.invoicing_notes'
      ></v-text-field>
    </wc-dialog>
 -->
    <wc-dialog
      title='Hold invoices'
      :icon='$icons.hold.icon'
      iconColor='error'
      :showDialog='showHoldDialog'
      @cancel='cancelEditHold'
      @save='updateHold'
      :disableButtons='!isFormValid'
    >
      Why should the invoices be put on hold?
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          :rules='[rules.required]'
          label='Hold reason'
          v-model='estimateCopy.hold_invoices_reason'
        ></v-text-field>
      </v-form>
      <template v-slot:dialog-actions v-if='estimateCopy.hold_invoices'>
        <v-btn @click='removeHold' small color='error' depressed >Remove Hold</v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'invoicing-notes',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Invoicing Holds',
    icon: 'mdi-currency-usd',
    iconColor: 'success',
    isFormValid: false,
    estimateCopy: [],
    customToolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }]
    ],
    showDialog: false,
    showHoldDialog: false
  }),
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showDialog = true
    },
    openEditHold () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showHoldDialog = true
      if (!this.estimateCopy.hold_invoices_reason) {
        setTimeout(() => {
          this.$refs.form.reset()
        }, 100)
      }
    },
    cancelEditHold () {
      this.showHoldDialog = false
    },
    saveChanges () {
      console.log('saving?')
      this.$emit('update', this.estimateCopy)
      this.showDialog = false
    },
    updateHold () {
      this.estimateCopy.hold_invoices = true
      this.$emit('update', this.estimateCopy)
      this.showHoldDialog = false
    },
    removeHold () {
      this.estimateCopy.hold_invoices = false
      this.estimateCopy.hold_invoices_reason = ''
      this.$emit('update', this.estimateCopy)
      this.showHoldDialog = false
    }
  }
}
</script>
